/**
 * Updates modal product information from JSON metadata
 * @param {Object} meta - The metadata object containing product information
 * @param {HTMLElement} modal - The modal element containing the product info elements
 */
export function updateModalProductInfo(meta, modal) {
    if (!meta || !modal) return;

    try {
        // Get all the modal elements
        const modalTitle = document.getElementById('modal-title');
        const modalDescription = document.getElementById('modal-description');
        const modalStyleLabel = document.getElementById('modal-style-label') || document.getElementById('bento-modal-style-label');
        const modalStyle = document.getElementById('modal-style') || document.getElementById('bento-modal-style');
        const modalCollectionLabel = document.getElementById('modal-collection-label') || document.getElementById('bento-modal-collection-label');
        const modalCollection = document.getElementById('modal-collection') || document.getElementById('bento-modal-collection');
        const modalStyleNumberLabel = document.getElementById('modal-style-number-label') || document.getElementById('bento-modal-style-number-label');
        const modalStyleNumber = document.getElementById('modal-style-number') || document.getElementById('bento-modal-style-number');
        const modalColorwayLabel = document.getElementById('modal-colorway-label') || document.getElementById('bento-modal-colorway-label');
        const modalColorway = document.getElementById('modal-colorway') || document.getElementById('bento-modal-colorway');
        const modalProductLink = modal?.querySelector('.cmp-gallery-productinfo__productlink');
        const modalLinks = document.getElementById('modal-links') || document.getElementById('bento-modal-links');
        const modalProductLinksSection = document.getElementById('modal-product-links-section');
        const modalAttribution = document.getElementById('modal-attribution') || document.getElementById('bento-modal-attribution');

        // Update title if present
        if (modalTitle) {
            modalTitle.innerHTML = meta.title || '';
        }

        // Update description if present
        if (modalDescription) {
            modalDescription.innerHTML = meta.description || '';
        }

        // Update style information
        if (modalStyleLabel) modalStyleLabel.innerHTML = meta.styleName ? 'Style' : '';
        if (modalStyle) modalStyle.innerHTML = meta.styleName || '';
        
        if (modalCollectionLabel) modalCollectionLabel.innerHTML = meta.collectionName ? 'Collection' : '';
        if (modalCollection) modalCollection.innerHTML = meta.collectionName || '';
        
        if (modalStyleNumberLabel) modalStyleNumberLabel.innerHTML = meta.styleNumber ? 'Style #' : '';
        if (modalStyleNumber) modalStyleNumber.innerHTML = meta.styleNumber || '';
        
        if (modalColorwayLabel) modalColorwayLabel.innerHTML = meta.colorwayName ? 'Colorway' : '';
        if (modalColorway) modalColorway.innerHTML = meta.colorwayName || '';

        // Update catalog URL link
        if (modalProductLink) {
            if (meta.catalogUrl) {
                modalProductLink.setAttribute('href', meta.catalogUrl);
                modalProductLink.classList.remove('cmp-gallery-productinfo__hidden');
            } else {
                modalProductLink.setAttribute('href', '');
                modalProductLink.classList.add('cmp-gallery-productinfo__hidden');
            }
        }

        // Update product links if present
        if (modalLinks) {
            if (meta.productLinks && meta.productLinks.length > 0) {
                modalLinks.innerHTML = meta.productLinks
                    .map(url => `<li><a href="${url}" class="cmp-imagegallery__modal-link">${url}</a></li>`)
                    .join('');
                if (modalProductLinksSection) {
                    modalProductLinksSection.style.display = '';
                }
            } else {
                modalLinks.innerHTML = '';
                if (modalProductLinksSection) {
                    modalProductLinksSection.style.display = 'none';
                }
            }
        }

        // Update attribution
        if (modalAttribution) {
            modalAttribution.innerHTML = meta.attribution || '';
        }
    } catch (e) {
        console.error('Error updating modal product info:', e);
    }
}

